/**
 * Whole-dollar price per door for card and list displays.
 * Returns an em dash when units are missing or invalid.
 */
export function formatPricePerDoor(purchasePrice, numberOfUnits, locale = 'fr-CA') {
  const units = Number(numberOfUnits);
  if (!Number.isFinite(units) || units <= 0) return '—';
  return Math.round(Number(purchasePrice || 0) / units).toLocaleString(locale, {
    maximumFractionDigits: 0,
  });
}
